import { createFileRoute } from '@tanstack/react-router';

import { RecordScreen } from '~/features/record/record-screen';
import { recordSearchSchema } from '~/features/record/record-search-schema';

/**
 * A record's entries (canvas 06-record). The same component as the entry
 * route below it, so opening an entry keeps this page as it was.
 */
export const Route = createFileRoute('/_app/records/$recordId/')({
  validateSearch: recordSearchSchema,
  component: RecordScreen,
});
